// ONB-PARENT step 1: the profile + language step (mock rev3 step 1, R-0137 language chips).
//   isDone  = the name has 2+ characters AND the phone, if typed, looks like a phone number. (The name is pre-filled from signup, so the step is usually already done.)
//   commit  = ONE profiles update on Next: preferred_lang (the language the user is looking at), plus display_name / phone only when they CHANGED. Same columns the Settings rows write.
//   Skip    = nothing is written (the shell never calls commit). A language chosen with the chips is only PREVIEWED locally (device), it is saved to the profile on Next.
const H = () => window.HUD;
const T = (k, v) => H().T(k, v);
const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };

// the name shown in the field: the real display name, never the e-mail prefix the account was created with
export function prefillName(session) {
  const n = String((session && session.displayName) || '').trim();
  return n && !n.includes('@') ? n : '';
}
export function nameOk(v) { return String(v || '').trim().length >= 2; }
// optional: empty is fine; otherwise 7-15 digits, only digits and the usual separators
export function phoneOk(v) {
  const s = String(v || '').trim(); if (!s) return true;
  if (!/^[+0-9()\-.\s]+$/.test(s)) return false;
  const d = s.replace(/\D/g, '').length; return d >= 7 && d <= 15;
}
// what to write: only what changed. lang is always included (the confirmed language).
export function buildPatch({ session, name, phone, lang }) {
  const patch = { preferred_lang: lang };
  const n = String(name || '').trim(), p = String(phone || '').trim();
  if (n && n !== String((session && session.displayName) || '').trim()) patch.display_name = n;
  if (p !== String((session && session.phone) || '').trim()) patch.phone = p || null;
  return patch;
}

export const profileStep = {
  id: 'profile', order: 10,
  label: () => T('onb_label_profile'),
  summary: (r) => (r === 'done' ? T('onb_sum_profile_done') : T('onb_sum_skipped', { label: T('onb_label_profile') })),
  mount(api) {
    const h = H(), s = h.session || {};
    const root = el('div');
    const ic = el('div', 'onb-icon', '👋'); ic.setAttribute('aria-hidden', 'true');
    const title = el('h2'), sub = el('p', 'onb-sub');
    const fName = el('div', 'onb-field'), lName = el('label'), iName = el('input');
    iName.type = 'text'; iName.id = 'onb-name'; iName.autocomplete = 'name'; iName.maxLength = 80; iName.value = prefillName(s); lName.htmlFor = 'onb-name';
    fName.append(lName, iName);
    const fPhone = el('div', 'onb-field'), lPhone = el('label'), iPhone = el('input');
    iPhone.type = 'tel'; iPhone.id = 'onb-phone'; iPhone.autocomplete = 'tel'; iPhone.inputMode = 'tel'; iPhone.maxLength = 24; iPhone.value = s.phone || ''; lPhone.htmlFor = 'onb-phone';
    const phoneErr = el('p', 'onb-hint-err'); phoneErr.setAttribute('data-phone-error', '1'); phoneErr.setAttribute('role', 'alert');
    fPhone.append(lPhone, iPhone, phoneErr);
    const fLang = el('div', 'onb-field'), lLang = el('label'); lLang.id = 'onb-lang-label';
    const chips = el('div', 'onb-chips'); chips.setAttribute('role', 'radiogroup'); chips.setAttribute('aria-labelledby', 'onb-lang-label');
    const langs = (h._availableLangs || [{ code: 'en', label: 'English' }, { code: 'he', label: 'Hebrew' }]).filter(l => l.code === 'en' || l.code === 'he');
    const chipEls = langs.map((l) => {
      const b = el('button', 'onb-chip'); b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('data-lang', l.code);
      const t = el('span', null, l.label); t.setAttribute('dir', 'auto'); b.appendChild(t);
      b.addEventListener('click', () => { if ((h._langNow || 'en') !== l.code) h._setLangPreview(l.code); paintChips(); });
      chips.appendChild(b); return b;
    });
    fLang.append(lLang, chips);
    const err = el('p', 'onb-error'); err.setAttribute('role', 'alert');
    root.append(ic, title, sub, fName, fPhone, fLang, err);
    function paintChips() { const cur = h._langNow || 'en'; chipEls.forEach((b) => b.setAttribute('aria-checked', b.getAttribute('data-lang') === cur ? 'true' : 'false')); }
    function texts() {
      title.textContent = T('onb_profile_title'); sub.textContent = T('onb_profile_sub');
      lName.textContent = T('onb_name_label'); iName.placeholder = T('onb_name_ph');
      lPhone.textContent = T('onb_phone_label'); iPhone.placeholder = T('onb_phone_ph');
      lLang.textContent = T('onb_lang_label'); paintChips();
      phoneErr.textContent = phoneOk(iPhone.value) ? '' : T('onb_phone_invalid');
    }
    texts();
    iName.addEventListener('input', () => api.refresh());
    iPhone.addEventListener('input', () => { phoneErr.textContent = phoneOk(iPhone.value) ? '' : T('onb_phone_invalid'); api.refresh(); });
    return {
      el: root,
      isDone: () => nameOk(iName.value) && phoneOk(iPhone.value),
      async commit() {
        const sess = h.session; if (!sess || !sess.id) return { ok: false, error: T('onb_error_generic') };
        const patch = buildPatch({ session: sess, name: iName.value, phone: iPhone.value, lang: h._langNow || 'en' });
        const { error } = await h._supa.from('profiles').update(patch).eq('id', sess.id);
        if (error) { console.error('❌ onboarding profile save:', error); return { ok: false, error: T('onb_error_generic') }; }
        if (patch.display_name) { sess.displayName = patch.display_name; sess.name = patch.display_name.split(' ')[0]; }
        if ('phone' in patch) sess.phone = patch.phone;
        return { ok: true };
      },
      onEnter() { if (!iName.value) setTimeout(() => { try { iName.focus({ preventScroll: true }); } catch (_) {} }, 0); },
      relang: texts,
    };
  },
};
